<div class="footer fixed d-none d-lg-block">
  <strong>Copyright</strong> Square Services Sàrl &copy;
  2017-{{moment.getFullYear()}} <span *ngIf="user?.isBookingValidator()"> | Version: {{version.version}} | Environment:
  {{version.environment}} | Build: {{version.buildtime | date }} | Ecawin:
  {{version.lastEcawinData | amTimeAgo}} | Uptime:
  {{version.startTime | amTimeAgo}}</span>
</div>
